import type {AccessToken} from 'Utility/authManager';
import authManager from 'Utility/authManager';
import {getEnvironmentVariable} from 'Utility/document';

const request = async (
  input: string,
  init?: RequestInit
): Promise<Response> => {
  const accessToken: AccessToken = await authManager.getAccessToken();

  const baseUrl = getEnvironmentVariable('SVELTE_APP_API_HOST');

  return fetch(`${baseUrl}${input}`, {
    ...init,
    headers: {
      ...init.headers,
      Authorization: `Bearer ${accessToken.access_token}`,
    },
  });
};

const get = (input: string, init?: RequestInit): Promise<Response> => {
  return request(input, {...init, method: 'GET'});
};

const post = (input: string, init?: RequestInit): Promise<Response> => {
  return request(input, {...init, method: 'POST'});
};

const put = (input: string, init?: RequestInit): Promise<Response> => {
  return request(input, {...init, method: 'PUT'});
};

const patch = (input: string, init?: RequestInit): Promise<Response> => {
  return request(input, {...init, method: 'PATCH'});
};

const deleteMethod = (input: string, init?: RequestInit): Promise<Response> => {
  return request(input, {...init, method: 'DELETE'});
};

const create = () => {
  return {
    request,
    get,
    post,
    put,
    patch,
    delete: deleteMethod,
  };
};

/**
 * @deprecated This function will be removed in future releases.
 * Please use the new API client instead.
 */
export default create();
